/** Platform-verified trusted host (admin-granted; e.g. established schools). */
export function isVerifiedHost(account) {
  const organizer = account;
  return Boolean(organizer?.verified_host);
}

/**
 * Where the "Host something fun" CTA navigates. Every signed-in user can host;
 * signed-out visitors are sent through sign-in first.
 */
export function hostCtaTarget(account) {
  const organizer = account;
  if (organizer) {
    return { path: "/create", label: "Host something fun" };
  }
  return { path: "/login?next=/create", label: "Host something fun" };
}
